var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"main",style:(_vm.bgHeadImg)},[_c('Header',{ref:"head"}),_c('div',{staticClass:"mainbox"},[(_vm.isRouterAlive1)?_c('div',{},[_c('router-view')],1):_vm._e()]),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }